export const BASKET_MODAL_CONTENT_LABEL = 'Add to Basket Modal';
export const BASKET_MODAL_TOTAL = 'Basket total';
export const BASKET_MODAL_QUANTITY = 'Qty';
export const BASKET_MODAL_HEADER = 'Item added to basket';
export const BASKET_MODAL_HEADER_EDIT = 'Changes saved';
export const BASKET_MODAL_BUTTON_CONTINUE = 'Continue shopping';
export const BASKET_MODAL_BUTTON_CTA = 'Go to basket';
